module.exports = __webpack_public_path__ + "a810f59762dce6c5599be7cbb6ef9f3f.wmv";